import React from 'react';
import { Reservation } from '../../types';
import './ReservationExtendChoicePopover.css';

export interface ExtendCandidateOption {
  reservation: Reservation;
  edge: 'checkin' | 'checkout';
  nights: number;
}

interface ReservationExtendChoicePopoverProps {
  candidates: ExtendCandidateOption[];
  anchorRect: DOMRect;
  onChoose: (candidate: ExtendCandidateOption) => void;
  onCancel: () => void;
}

const describeCandidate = (c: ExtendCandidateOption): string => {
  const nightsLabel = `${c.nights} night${c.nights > 1 ? 's' : ''}`;
  return c.edge === 'checkin'
    ? `Extend ${c.reservation.guestName}'s check-in earlier (+${nightsLabel})`
    : `Extend ${c.reservation.guestName}'s stay (+${nightsLabel})`;
};

const ReservationExtendChoicePopover: React.FC<ReservationExtendChoicePopoverProps> = ({
  candidates,
  anchorRect,
  onChoose,
  onCancel,
}) => {
  const style = (() => {
    const width = 280;
    const top = Math.min(anchorRect.bottom + 6, window.innerHeight - 40);
    const left = Math.min(Math.max(8, anchorRect.left), window.innerWidth - width - 8);
    return { top, left, width };
  })();

  return (
    <>
      <div className="extend-choice-popover-backdrop" onClick={onCancel} />
      <div className="extend-choice-popover" style={style}>
        <div className="extend-choice-popover-title">Which reservation would you like to extend?</div>
        <div className="extend-choice-popover-options">
          {candidates.map((c, i) => (
            <button
              key={i}
              className="extend-choice-option"
              onClick={() => onChoose(c)}
            >
              {describeCandidate(c)}
            </button>
          ))}
        </div>
        <div className="extend-choice-popover-actions">
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </>
  );
};

export default ReservationExtendChoicePopover;
